module.exports = __webpack_public_path__ + "img/Coinbase1.daf89b2d.png";